import { FiCheck, FiLock } from "react-icons/fi";
import useTranslator from "../../hooks/useTranslator";
import styles from "./DocumentAnalysisLoading.module.css";

const DocumentAnalysisLoadingPopup = ({
  showPopup,
  isGuarantor,
  documentCount,
}) => {
  const { _t } = useTranslator();

  if (!showPopup) return null;

  const count =
    typeof documentCount === "number" && Number.isFinite(documentCount)
      ? documentCount
      : null;

  const title =
    count !== null && count > 0
      ? _t(
          "analyzingYourDocumentsCount",
          count === 1
            ? "Analyzing your 1 document"
            : `Analyzing your ${count} documents`,
          { count }
        )
      : _t("analyzingYourDocuments", "Analyzing your documents");

  return (
    <div
      className={`popup-overlay fixed inset-0 bg-black bg-opacity-50 modal-fixed-screen flex z-50 wrapper-modal ${styles.overlay} ${isGuarantor ? "guarantorBg" : ""}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className={styles.card} onClick={(e) => e.stopPropagation()}>
        <span className={styles.spinner} aria-hidden="true" />

        <div className={styles.intro}>
          <h3>{title}</h3>
          <p>
            {_t(
              "analyzingDocumentsSubtitle",
              "A few seconds. Don't close this window."
            )}
          </p>
        </div>

        <div className={styles.steps}>
          <div className={styles.step}>
            <FiCheck aria-hidden="true" />
            <span>{_t("readingYourFiles", "Reading your files")}</span>
          </div>
          <div className={styles.step}>
            <FiCheck aria-hidden="true" />
            <span>
              {_t("checkingForDuplicates", "Checking for duplicates")}
            </span>
          </div>
          <div className={styles.step}>
            <span className={styles.stepSpinner} aria-hidden="true" />
            <span>
              {_t(
                "verifyingDocumentsAreYours",
                "Verifying the documents are yours"
              )}
            </span>
          </div>
        </div>

        <div className={styles.encrypted}>
          <FiLock aria-hidden="true" />
          <span>{_t("dataTravelsEncrypted", "Data travels encrypted")}</span>
        </div>
      </div>
    </div>
  );
};

export default DocumentAnalysisLoadingPopup;
